export default __webpack_public_path__ + "static/media/la_maria_y_la_cota.df4b5056.png";